import UserService from "services/UserService";
import { setUser } from "reduxStore/slices/globalSlice";
import store from "reduxStore/store";
import {
  PLEASE_ENTER_PASSWORD,
  PLEASE_ENTER_PASSWORD_8_CHARACTERS,
  PASSWORD_MUST_CONTAIN_NUMBER,
  PASSWORD_MUST_CONTAIN_UPPERCASE,
  PASSWORD_MUST_CONTAIN_LOWERCASE,
  PASSWORD_MUST_CONTAIN_SPECIAL_CHARACTER,
} from "configurations/MessageConstants";
import { SESSION_EXPIRED, LOCAL_STORAGE_KEYS } from "configurations/Constants";

let refreshTokenPromise = null;

export const AuthHelper = {
  isValidEmail: (email) => {
    if (!email) return false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  },

  isValidPassword: (value) => {
    const trimmedValue = value.trim();
    switch (true) {
      case trimmedValue === "":
        return PLEASE_ENTER_PASSWORD;
      case trimmedValue.length < 8:
        return PLEASE_ENTER_PASSWORD_8_CHARACTERS;
      case !/\d/.test(value):
        return PASSWORD_MUST_CONTAIN_NUMBER;
      case !/[A-Z]/.test(value):
        return PASSWORD_MUST_CONTAIN_UPPERCASE;
      case !/[a-z]/.test(value):
        return PASSWORD_MUST_CONTAIN_LOWERCASE;
      case !/[!@#$%^&*(),.?":{}|<>]/.test(value):
        return PASSWORD_MUST_CONTAIN_SPECIAL_CHARACTER;
      default:
        return true;
    }
  },

  setToken: (email, idToken, accessToken, refreshToken) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.EMAIL, email);
    localStorage.setItem(LOCAL_STORAGE_KEYS.ID_TOKEN, idToken);
    localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    localStorage.setItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
  },

  sessionExpired: () => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.SESSION_EXPIRED, true);
    AuthHelper.clearSession();
  },

  clearSession: () => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.EMAIL);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.ID_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
    store.dispatch(setUser({}));
  },

  handleRefreshToken: async () => {
    const idToken = localStorage.getItem(LOCAL_STORAGE_KEYS.ID_TOKEN);
    if (!idToken) return;
    const base64Url = idToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const eData = JSON.parse(atob(base64));
    const currentTime = parseInt(Number(new Date()) / 1000);
    if (currentTime > eData.exp - 900) {
      if (refreshTokenPromise) {
        return refreshTokenPromise;
      }
      refreshTokenPromise = (async () => {
        try {
          const refreshToken = localStorage.getItem(
            LOCAL_STORAGE_KEYS.REFRESH_TOKEN
          );
          const email = localStorage.getItem(LOCAL_STORAGE_KEYS.EMAIL);
          const response = await UserService.refreshToken(email, refreshToken);
          if (response.success) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.ID_TOKEN, response.idToken);
            localStorage.setItem(
              LOCAL_STORAGE_KEYS.ACCESS_TOKEN,
              response.accessToken
            );
            return true;
          }
          return false;
        } catch (error) {
          return false;
        } finally {
          refreshTokenPromise = null;
        }
      })();
      return refreshTokenPromise;
    }
    return true;
  },
};
